import { useState } from "react";

import { Button } from "capitalrx-components-2.0/lib/general";
import { Shelf, useResponsive } from "capitalrx-components-2.0/lib/layout";

import "./ToggleButton.scss";

export type ToggleStatus = "first" | "second";

interface ToggleButtonProps {
  readonly onChange: (value: ToggleStatus) => void;
  readonly firstText: string;
  readonly secondText: string;
  readonly value?: ToggleStatus;
}

export const ToggleButton = ({ onChange, firstText, secondText, value = "first" }: ToggleButtonProps) => {
  const [currentToggle, setCurrentToggle] = useState<ToggleStatus>(value || "first");

  const handleToggleChange = (toggle: ToggleStatus) => {
    setCurrentToggle(toggle);
    onChange(toggle);
  };

  const { sizing } = useResponsive({
    sizing: {
      mobile: "mobileToggle",
      tablet: "tabletToggle",
      desktop: "desktopToggle",
    },
  });

  return (
    <div className={`toggleButtonContainer ${sizing}`}>
      <Shelf spacing="small">
        <Button
          tabIndex={0}
          className="networkToggleButton"
          appearance={currentToggle === "first" ? "primary" : "text"}
          onClick={() => handleToggleChange("first")}
        >
          {firstText}
        </Button>
        <Button
          tabIndex={1}
          className="networkToggleButton"
          appearance={currentToggle === "second" ? "primary" : "text"}
          onClick={() => handleToggleChange("second")}
        >
          {secondText}
        </Button>
      </Shelf>
    </div>
  );
};
